import {
  Document,
  FromServerDocument,
  ToServerDocumentWithMetadata,
} from 'notebook/documents/DocumentConstants';
import {CidIdMap, CidNotePartProvenanceIdMap} from 'notebook/notes/NoteConstants';
import {ServerDocumentEditorLock} from 'notebook/realtime/DocumentEditorLockConstants';
import * as net from 'util/Net';

export interface DocumentsByVersion {
  [documentVersion: string]: Array<Document>;
}

const DocumentDAO = {
  get: (id: string): JQueryPromise<FromServerDocument> => net.getJSON(`/1/api/documents/${id}`, {view: true}),

  getVersions: (id: string): JQueryPromise<DocumentsByVersion> =>
    net.getJSON(`/1/api/documents/${id}/versions/`),

  update: (
    id: string,
    data: ToServerDocumentWithMetadata
  ): JQueryPromise<{
    cidIdMap: CidIdMap;
    cidNotePartProvenanceIdMap?: CidNotePartProvenanceIdMap;
    lock?: ServerDocumentEditorLock;
  }> => net.patchJSON({url: `/1/api/documents/${id}`, data}),

  getVersion: (id: string, versionId: string | number): JQueryPromise<FromServerDocument> =>
    net.getJSON(`/1/api/documents/${id}/versions/${versionId}`),
};

export default DocumentDAO;
